
export const SaveChangesBoxStyle = {
  position: "sticky",
  bottom: 0,
  display: "flex",
  justifyContent: "flex-end",
  marginTop: 2,
  gap: 3,
  backgroundColor: "white",
  padding: "24px",
  borderTop: "1px solid #ECEEFB",
  borderRadius: "0px 0px 20px 20px",
};